var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cp-robot" },
    [
      _vm.robot3Show
        ? [
            _c("transition", { attrs: { name: "fadeUp" } }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isTabsVisible,
                      expression: "!isTabsVisible"
                    }
                  ],
                  staticClass: "tabs fixed"
                },
                [
                  _c("router-link", { attrs: { to: "/robot3s/info" } }, [
                    _vm._v("机器人")
                  ]),
                  _c("router-link", { attrs: { to: "/robot3s/design" } }, [
                    _vm._v("平台")
                  ]),
                  _c("router-link", { attrs: { to: "/robot3s/spec" } }, [
                    _vm._v("技术规格")
                  ])
                ],
                1
              )
            ]),
            _c(
              "div",
              { staticClass: "tabs", attrs: { id: "tabs" } },
              [
                _c("router-link", { attrs: { to: "/robot3s/info" } }, [
                  _vm._v("机器人")
                ]),
                _c("router-link", { attrs: { to: "/robot3s/design" } }, [
                  _vm._v("平台")
                ]),
                _c("router-link", { attrs: { to: "/robot3s/spec" } }, [
                  _vm._v("技术规格")
                ])
              ],
              1
            ),
            _c("router-view")
          ]
        : [
            _c("div", { attrs: { id: "robot3s-default-banner" } }, [
              _c("div", { staticClass: "w" }, [
                _vm.isMobile
                  ? _c("div", { staticClass: "p1 fadeUp" }, [
                      _vm._v(" 11.15日"),
                      _c("br"),
                      _vm._v("深圳新品发布会")
                    ])
                  : _c("div", { staticClass: "p1 fadeUp" }, [
                      _vm._v("11.15日·深圳新品发布会")
                    ]),
                _c("div", { staticClass: "p2 fadeDown delay1" })
              ])
            ])
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b826b08", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b826b08","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/robot/3s/index.vue
// module id = miFu
// module chunks = 0